export default {
  en: {
    'offers': 'offers',
    'transfer_market': 'transfer market',
    'base_price': 'base price',
    'offer_for_player_x': 'Offer for {player}',
    'transfer_of_player_x': 'Transfer of {player}',
    'transfer_can_not_be_reverted': 'Transfer can not be reverted!',
    'are_you_sure_you_want_to_abort_all_negotiations?': 'Are you sure you want to abort all negotiations?',
    'target': 'target',
    'details': 'details',
    'aborted': 'aborted',
    'immediately': 'immediately',
    'when': 'when',
    'no_offers_exist': 'No offers exist.',
    'no_listings_exist': 'No listings exist.',
    'list_on_transfer_market': 'list on transfer market',
    'remove_from_market': 'remove from market',
    'terminate_contract': 'terminate contract',
    'received_offer_for_player_x': 'Received offer for {player}.',
    'offer_abort_for_player_x': 'Negotiation with {team} aborted offer for {player}.',
    'you_can_remove_player_from_the_transfer_market_any_time': 'You can remove player from the transfer market any time.',
    'when_you_remove_the_player_from_the_transfer_market_all_offers_will_to_lost': 'When you remove the player from the transfer market all offers will tolost.',
    'are_you_sure_you_want_to_terminate_players_contract?': 'Are you sure you want to terminate players contract?',
    'the_process_can_not_be_reverted': 'The process can not be reverted.',
    'confirm_your_decision': 'confirm your decision',
    'player_has_been_transferred_this_season_already': 'Player has been transferred this season already.',
    'my_listings': 'my listings',
    'transfer_negotiations_aborted_due_to_player_ending_career': 'Transfer negotiations with {player} aborted due to player decided to end his career.',
    'contract_negotiations_aborted_due_to_player_ending_career': 'Contract negotiations with {player} aborted due to player decided to end his career.',
    '': '',
  }
};
